const deepCopy = (data: any) => JSON.parse(JSON.stringify(data));

export { deepCopy };
